import React from "react";
import { Link } from "react-router-dom";
import { Orbit, Linkedin, Twitter, Mail } from "lucide-react";
import { siteData } from "../mock";

const Footer = () => {
  return (
    <footer className="relative bg-[#030509] text-white/70 border-t border-white/5 overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-blue-500/60 to-transparent" />
      <div className="absolute -top-10 left-1/2 -translate-x-1/2 w-[600px] h-40 bg-blue-500/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <Link to="/" className="flex items-center gap-2.5">
            <span className="relative w-9 h-9 rounded-full bg-gradient-to-br from-blue-500 via-indigo-500 to-purple-600 flex items-center justify-center shadow-[0_0_20px_-4px_rgba(99,102,241,0.7)]">
              <Orbit className="w-4 h-4 text-white" strokeWidth={2.2} />
            </span>
            <span className="font-bold tracking-tight text-lg text-white">
              com<span className="bg-gradient-to-r from-blue-400 to-indigo-400 bg-clip-text text-transparent">PLANET</span>
            </span>
          </Link>
          <p className="mt-4 text-sm leading-relaxed text-white/60 max-w-xs">
            {siteData.footer.tagline}
          </p>
          <div className="mt-5 flex items-center gap-3">
            {[
              { Icon: Linkedin, href: "#linkedin", label: "LinkedIn" },
              { Icon: Twitter,  href: "#twitter",  label: "Twitter"  },
              { Icon: Mail,     href: "mailto:adamn1224@gmail.com", label: "Email" },
            ].map(({ Icon, href, label }) => (
              <a
                key={label}
                href={href}
                aria-label={label}
                className="w-9 h-9 rounded-full bg-white/[0.06] border border-white/10 hover:border-blue-400/50 hover:bg-blue-500/20 hover:text-white flex items-center justify-center transition-colors"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        {siteData.footer.columns.map((col, i) => (
          <div key={i}>
            <p className="text-white font-semibold mb-4">{col.title}</p>
            <ul className="space-y-2 text-sm">
              {col.links.map((l, k) => (
                <li key={k}>
                  <a href="#" className="text-white/60 hover:text-white hover:pl-1 transition-all inline-block">{l}</a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>{siteData.footer.copyright}</p>
          <div className="flex items-center gap-5">
            <a href="#privacy" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#terms" className="hover:text-white transition-colors">Terms</a>
            <a href="#cookies" className="hover:text-white transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
